<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': 'CadastrarClientes'}" class="button big block-mobile float-right hidden-lg hidden-md">
                                <i class="material-icons">add</i>
                                Cadastrar cliente
                            </router-link>
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-20 hidden-xl hidden-sm">
                            <router-link :to="{'name': 'CadastrarClientes'}" class="button big block-mobile">
                                <i class="material-icons">add</i>
                                Cadastrar cliente
                            </router-link>
                        </div>   
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-7 col-xs-12 col-xl-6 col-md-7">
                                        <div class="submit-field">
                                            <h5>Pesquisar cliente:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Nome, e-mail, telefone ou CNPJ.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-4">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div>
                                            <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray " type="submit">
                                                <i class="material-icons">search</i>
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 50px; width: 50px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            E-mail
                                        </th>
                                        <th style="min-width: 112px">
                                            Telefone
                                        </th>
                                        <!-- <th style="min-width: 140px; width: 140px;">
                                            CNPJ
                                        </th>      -->                                                                                                  
                                        <th>
                                            Cadastro
                                        </th>     
                                        <th style="min-width: 135px; width: 135px;">
                                            Ações
                                        </th>                                 
                                    </thead>
                                    <tbody>   
<!--                                         <tr>
                                            <td data-label="ID">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    129
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    <u>Empresa testes</u>
                                                </router-link>
                                            </td>
                                            <td data-label="E-mail">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    email@exemplo.com.br
                                                </router-link>
                                            </td>                   
                                            <td data-label="Telefone">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    47999999999
                                                </router-link>
                                            </td>
                                            <td data-label="CNPJ">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    11.646.922/0001-9
                                                </router-link>
                                            </td>                                                                
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': 'GerenciarClientes'}">
                                                    07/07/2020 12:52
                                                </router-link>
                                            </td>                                                                                             
                                        </tr>
                                         -->

                                        <tr v-for="item in data.itens">
                                            <td data-label="ID">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    {{item.id}}

                                                    <span v-if="item.suspenso == 1" class="dashboard-status-button color-red hidden-lg hidden-xl" style="float: right;">
                                                        <i class="material-icons" style="color: #fff;">block</i>
                                                        Cliente suspenso para faturamento
                                                    </span>

                                                    <span v-if="item.dividas == 1" class="dashboard-status-button color-red hidden-lg hidden-xl" style="float: right;">
                                                        <i class="material-icons" style="color: #fff;">block</i>
                                                        Faturamento não aprovado
                                                    </span>

                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    <u>{{item.nome ? item.nome : item.razaoSocial}}</u>
                                                    <div class="clearfix margin-top-5"></div>
                                                    <small v-show="item.doc && item.tipo == 'Pessoa Jurídica'">
                                                        <i class="material-icons">verified_user</i> <b>CNPJ:</b> {{item.doc}}
                                                        
                                                        <span v-if="item.suspenso == 1" class="dashboard-status-button color-red hidden-xs hidden-md" style="float: right; margin-right: 5px;">
                                                            <i class="material-icons" style="color: #fff;">block</i>
                                                            Cliente suspenso para faturamento
                                                        </span>

                                                        <span v-if="item.dividas == 1" class="dashboard-status-button color-red hidden-xs hidden-md" style="float: right; margin-right: 5px;">
                                                            <i class="material-icons" style="color: #fff;">block</i>
                                                            Faturamento não aprovado
                                                        </span>

                                                    </small>
                                                </router-link>
                                            </td>
                                            <td data-label="E-mail">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    {{item.email[0]}}
                                                </router-link>
                                            </td>                   
                                            <td data-label="Telefone">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    {{item.telefone[0]}}
                                                </router-link>
                                            </td>
<!--                                             <td data-label="CNPJ">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    {{item.doc}}
                                                </router-link>
                                            </td>  -->                                                               
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}">
                                                    {{item.datahora | formatDate}}
                                                </router-link>
                                            </td>   
                                            <td data-label="Ações">
                                                <router-link :to="{'name': 'EditarClientes', 'query': {'c': item.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                <a class="dashboard-status-button color-red" v-on:click="del(item.cod)">Apagar</a>                                                                                      
                                            </td>  
                                        </tr>
                                        
                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination" v-show="$root.internet.online">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Clientes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "db":                   {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        getDB: function() {
            console.log("getDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["clientes"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("clientes find()", "ok:", result);
                    if (result.rows.length > 0) {
                        self.db.itens     = result.rows[0].doc.result.result.itens;
                    } else {
                        self.db.itens     = [];
                    }
                    loading.hide();
                    self.$forceUpdate();

                    console.log("Setou clientes:", self.db)
                    resolve(self.db.itens)

                }).catch(function (err) {
                    console.log("clientes find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },        
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }

                if (self.form.pesquisa && !self.$root.internet.online) {
                    console.log("Esta pesquisando offline")

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(self.form.pesquisa);

                    self.db.itens.forEach(function(item) {
                        if (clean(item.nome).indexOf(search) != -1 || clean(item.doc).indexOf(search) != -1 || clean(item.razaoSocial).indexOf(search) != -1) {
                            itens.push(item);
                        }
                    });
                    console.log("Resultado pesquisa itens", itens)
                    self.data.itens = itens;
                    loading.hide();
                    resolve(itens);

                } else {
                    axios.get("api/clientes.php", {params: self.form, db: "clientes"})
                    .then(response => {
                        
                        console.log("get() response", response);
                        self.data   = response.data.result; 
                        self.loaded = true;
                        loading.hide();
                        self.$root.scrollTop();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("get() error", error);                    
                        loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });   
                }
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/clientes.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
                self.getDB();
            });
        } else {
            self.get();
            self.getDB();
        }  
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Clientes.vue